import * as HciHospAPI from './';
import {hciQuery, hciGetPicture, hciCdsCheck} from './api';
export {hciQuery, hciGetPicture, hciCdsCheck};
export {HciHospAPI};


// WEBPACK FOOTER //
// ./src/index.ts